import React, { useState } from 'react';
import { Nav, NavDropdown } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import { FaTachometerAlt, FaUsers, FaBox, FaShoppingCart, FaVideo, FaLifeRing, FaCog, FaUserMd } from 'react-icons/fa';

const Sidebar = () => {
  const [openDropdown, setOpenDropdown] = useState(null);

  const handleDropdownClick = (dropdown) => {
    setOpenDropdown(openDropdown === dropdown ? null : dropdown);
  };

  const navLinkStyle = {
    color: '#FFFFFF', // White color for all text initially
    fontWeight: '600', // Making text heavier
  };

  const dropdownStyle = {
    color: '#FFFFFF', // White color for dropdown titles initially
    fontWeight: '600', // Making text heavier
  };

  const customDropdownStyles = `
    .sidebar .dropdown-menu {
      width: 100%;
      hieght:100%;
      background-color: white;
      border: none;
      border-radius: 0;
      box-shadow: 0 4px 8px rgba(0,0,0,0.1);
    }
    .sidebar .dropdown-toggle::after {
      color: #FFFFFF;
    }
    .sidebar .dropdown-item {
      color: #333333; // Dark grey color for items
      font-weight: 500;
    }
    .sidebar .dropdown-item:hover {
      background-color: #f8f9fa; // Light grey background on hover
    }
    .sidebar .nav-link:hover,
    .sidebar .dropdown-toggle:hover {
      color: #FF50A2; // Sidebar background color on hover
      background-color: #f8f9fa; // Light grey background on hover
    }
  `;
  
  return (
    <>
      <style>{customDropdownStyles}</style>
      <Nav className="col-md-3 col-lg-2 d-md-block sidebar collapse vh-100" style={{ backgroundColor: '#FF50A2',height: '100%' }}>
        <div className="position-sticky pt-3">
          <div className="text-center py-4">
            <img
              src="/images/appLogo.png"
              alt="Logo"
              style={{ width: '120px', height: '120px', marginBottom: '-38px'}}
            />
          </div>
          <hr style={{margin: '10px'}}></hr>
          <Nav.Item>
            <Nav.Link as={Link} to="/dashboard" style={navLinkStyle}>
              <FaTachometerAlt className="me-2" />
              Dashboard
            </Nav.Link>
          </Nav.Item>
          <hr style={{margin: '1px'}}></hr>
          <NavDropdown
            title={<span style={dropdownStyle}><FaUsers className="me-2" /> User Management</span>}
            id="user-management-dropdown"
            show={openDropdown === 'user-management'}
            onClick={() => handleDropdownClick('user-management')}
          >
            <NavDropdown.Item as={Link} to="/users">Users</NavDropdown.Item>
            <NavDropdown.Item as={Link} to="/Subscriptions">Subscriptions</NavDropdown.Item>
            <NavDropdown.Item as={Link} to="/plans">Plans</NavDropdown.Item>
          </NavDropdown>
          <hr style={{margin: '1px'}}></hr>
          <Nav.Item>
            <Nav.Link as={Link} to="/services" style={navLinkStyle}>
              <FaTachometerAlt className="me-2" />
              Services
            </Nav.Link>
          </Nav.Item>
          <hr style={{margin: '1px'}}></hr>
          <NavDropdown
            title={<span style={dropdownStyle}><FaUserMd className="me-2" /> Provider</span>}
            id="provider-dropdown"
            show={openDropdown === 'provider'}
            onClick={() => handleDropdownClick('provider')}
          >
            <NavDropdown.Item as={Link} to="/provider-list">Provider List</NavDropdown.Item>
            <NavDropdown.Item as={Link} to="/Appointments">Appointments</NavDropdown.Item>
          </NavDropdown>
          <hr style={{margin: '1px'}}></hr>
          <Nav.Item>
            <Nav.Link as={Link} to="/products" style={navLinkStyle}>
              <FaBox className="me-2" />
              Products
            </Nav.Link>
          </Nav.Item>
          <hr style={{margin: '1px'}}></hr>
          <Nav.Item>
            <Nav.Link as={Link} to="/orders" style={navLinkStyle}>
              <FaShoppingCart className="me-2" />
              Orders
            </Nav.Link>
          </Nav.Item>
          <hr style={{margin: '1px'}}></hr>
          <Nav.Item>
            <Nav.Link as={Link} to="/LabServiceManagement" style={navLinkStyle}>
              <FaShoppingCart className="me-2" />
              Lab Service
            </Nav.Link>
          </Nav.Item>
          <hr style={{margin: '1px'}}></hr>
          <Nav.Item>
            <Nav.Link as={Link} to="/blogs" style={navLinkStyle}>
              <FaVideo className="me-2" />
              Blog
            </Nav.Link>
          </Nav.Item>
          <hr style={{margin: '1px'}}></hr>
          <NavDropdown
            title={<span style={dropdownStyle}><FaVideo className="me-2" /> Videos</span>}
            id="videos-dropdown"
            show={openDropdown === 'videos'}
            onClick={() => handleDropdownClick('videos')}
          >
            <NavDropdown.Item as={Link} to="/videos">Fitness</NavDropdown.Item>
            <NavDropdown.Item as={Link} to="/MentalHealthVideos">Mental Health</NavDropdown.Item>
          </NavDropdown>
          <hr style={{margin: '1px'}}></hr>
          <Nav.Item>
            <Nav.Link as={Link} to="/Billings" style={navLinkStyle}>
              <FaLifeRing className="me-2" />
              Billings
            </Nav.Link>
          </Nav.Item>
          <hr style={{margin: '1px'}}></hr>
           <Nav.Item>
            <Nav.Link as={Link} to="/alltransaction" style={navLinkStyle}>
              <FaLifeRing className="me-2" />
              All Transaction
            </Nav.Link>
          </Nav.Item>

        </div>
      </Nav>
      
    </>
  );
};

export default Sidebar;
